const a = {
  "@ado/base-application": {
    footer: {
      "terms-of-use": (e) => {
        const { normalize: n } = e;
        return n(["T\xE9rminos y Condiciones"]);
      },
      disclaimer: (e) => {
        const { normalize: n } = e;
        return n(["Limitaci\xF3n de Responsabilidad"]);
      },
      "about-us": (e) => {
        const { normalize: n } = e;
        return n(["Sobre nosotros"]);
      },
      "cookie-policy": (e) => {
        const { normalize: n } = e;
        return n(["Pol\xEDtica de cookies"]);
      },
      "privacy-policy": (e) => {
        const { normalize: n } = e;
        return n(["Pol\xEDtica de Privacidad"]);
      },
      "google-privacy-policy": (e) => {
        const { normalize: n } = e;
        return n(["Pol\xEDtica de Privacidad"]);
      },
      "editorial-policy": (e) => {
        const { normalize: n } = e;
        return n(["Pol\xEDtica Editorial"]);
      },
      "terms-of-service": (e) => {
        const { normalize: n } = e;
        return n(["T\xE9rminos y Condiciones"]);
      },
      "use-of-site": (e) => {
        const { normalize: n, interpolate: r, named: o } = e;
        return n(["El uso de este sitio web est\xE1 sujeto a nuestros ", r(o("tos")), ", ", r(o("disclaimer")), ", ", r(o("cookiePolicy")), " ", r(o("privacyPolicy")), " y ", r(o("editorialPolicy")), "."]);
      },
      "recaptcha-google": (e) => {
        const { normalize: n, interpolate: r, named: o } = e;
        return n(["Este sitio web es protegido mediante el uso de tecnolog\xEDa reCAPTCHA de Google ", r(o("googlePrivacyPolicy")), " y ", r(o("googleTos")), " aplicar."]);
      },
      consent: (e) => {
        const { normalize: n, interpolate: r, named: o } = e;
        return n([r(o("siteBrand")), " no es un despacho de abogados y no proporciona asesoramiento legal a tal efecto.Proporcionamos information y software, y el usuario es plenamente responsable del uso de este material. ", r(o("copyRight"))]);
      },
      "all-rights-reserved": (e) => {
        const { normalize: n } = e;
        return n(["Todos los derechos reservados"]);
      },
      "terms-of-use-title": (e) => {
        const { normalize: n } = e;
        return n(["T\xE9rminos y Condiciones"]);
      },
      "disclaimer-title": (e) => {
        const { normalize: n } = e;
        return n(["Limitaci\xF3n de Responsabilidad"]);
      },
      "privacy-policy-title": (e) => {
        const { normalize: n } = e;
        return n(["Pol\xEDtica de Privacidad"]);
      },
      "editorial-policy-title": (e) => {
        const { normalize: n } = e;
        return n(["Pol\xEDtica Editorial"]);
      }
    },
    "footer-links": {
      about: (e) => {
        const { normalize: n } = e;
        return n(["Sobre nosotros"]);
      },
      "affilicate-program": (e) => {
        const { normalize: n } = e;
        return n(["Programa De Afiliados"]);
      },
      blog: (e) => {
        const { normalize: n } = e;
        return n(["Blog"]);
      },
      "business-solutions": (e) => {
        const { normalize: n } = e;
        return n(["Soluciones empresariales"]);
      },
      "cancel-page": (e) => {
        const { normalize: n } = e;
        return n([]);
      },
      careers: (e) => {
        const { normalize: n } = e;
        return n([]);
      },
      contact: (e) => {
        const { normalize: n } = e;
        return n(["Contacto"]);
      },
      home: (e) => {
        const { normalize: n } = e;
        return n(["Inicio"]);
      },
      "law-library": (e) => {
        const { normalize: n } = e;
        return n(["Biblioteca Jur\xEDdica"]);
      },
      "legal-documents": (e) => {
        const { normalize: n } = e;
        return n(["Documentos legales"]);
      },
      "legal-notice": (e) => {
        const { normalize: n } = e;
        return n([]);
      },
      resources: (e) => {
        const { normalize: n } = e;
        return n(["Recursos"]);
      },
      "white-label-program": (e) => {
        const { normalize: n } = e;
        return n(["Programa De Etiqueta Blanca"]);
      }
    },
    "footer-policy-dialog": {
      "print-document": (e) => {
        const { normalize: n } = e;
        return n([]);
      },
      "save-document": (e) => {
        const { normalize: n } = e;
        return n([]);
      }
    },
    help: (e) => {
      const { normalize: n } = e;
      return n(["Ayuda"]);
    },
    more: (e) => {
      const { normalize: n } = e;
      return n(["Ver m\xE1s"]);
    },
    or: (e) => {
      const { normalize: n } = e;
      return n(["o"]);
    },
    "help-center": (e) => {
      const { normalize: n } = e;
      return n(["Centro de ayuda"]);
    },
    countries: {
      "United States": (e) => {
        const { normalize: n } = e;
        return n(["Estados Unidos"]);
      },
      Australia: (e) => {
        const { normalize: n } = e;
        return n(["Australia"]);
      },
      Austria: (e) => {
        const { normalize: n } = e;
        return n(["Austria"]);
      },
      Canada: (e) => {
        const { normalize: n } = e;
        return n(["Canad\xE1"]);
      },
      "United Kingdom": (e) => {
        const { normalize: n } = e;
        return n(["Reino Unido"]);
      },
      Deutschland: (e) => {
        const { normalize: n } = e;
        return n(["Alemania"]);
      },
      France: (e) => {
        const { normalize: n } = e;
        return n(["Francia"]);
      },
      India: (e) => {
        const { normalize: n } = e;
        return n(["India"]);
      },
      Ireland: (e) => {
        const { normalize: n } = e;
        return n(["Irlanda"]);
      },
      Mexico: (e) => {
        const { normalize: n } = e;
        return n(["M\xE9xico"]);
      },
      "New Zealand": (e) => {
        const { normalize: n } = e;
        return n(["Nueva Zelanda"]);
      },
      Nigeria: (e) => {
        const { normalize: n } = e;
        return n(["Nigeria"]);
      },
      Singapore: (e) => {
        const { normalize: n } = e;
        return n(["Singapur"]);
      },
      Spain: (e) => {
        const { normalize: n } = e;
        return n(["Espa\xF1a"]);
      }
    },
    header: {
      "chat-online": (e) => {
        const { normalize: n } = e;
        return n(["Chatear en linea"]);
      },
      "email-us": (e) => {
        const { normalize: n } = e;
        return n(["Env\xEDanos un-e-mail"]);
      },
      "create-free-account": (e) => {
        const { normalize: n } = e;
        return n(["Crea una cuenta gratis"]);
      },
      "search-this-site": (e) => {
        const { normalize: n } = e;
        return n(["Buscar en este sitio..."]);
      },
      go: (e) => {
        const { normalize: n } = e;
        return n(["Ir"]);
      },
      "my-documents": (e) => {
        const { normalize: n } = e;
        return n(["Mis documentos"]);
      },
      "my-account": (e) => {
        const { normalize: n } = e;
        return n(["Mi cuenta"]);
      },
      "sign-out": (e) => {
        const { normalize: n } = e;
        return n(["Cerrar sesi\xF3n"]);
      },
      "upgrade-account": (e) => {
        const { normalize: n } = e;
        return n(["Actualizar cuenta"]);
      },
      "all-documents": (e) => {
        const { normalize: n, interpolate: r, named: o } = e;
        return n(["Todos los documentos de ", r(o("siteBrand"))]);
      },
      All: (e) => {
        const { normalize: n } = e;
        return n(["Todos"]);
      }
    },
    "sign-in": {
      "already-have-account": (e) => {
        const { normalize: n } = e;
        return n(["\xBFYa tiene una cuenta?"]);
      },
      "create-account-disclaimer": (e) => {
        const { normalize: n, interpolate: r, named: o } = e;
        return n(["Toda la informaci\xF3n que usted proporcione se conservar\xE1 de manera confidencial y no se comunicar\xE1 a otras empresas. Por favor, revise nuestra ", r(o("privacyPolicy")), ", ", r(o("tos")), ", y ", r(o("emailPolicy")), " para m\xE1s informaci\xF3n."]);
      },
      "create-an-account": (e) => {
        const { normalize: n } = e;
        return n(["Cree una cuenta gratuita"]);
      },
      "create-new-account": (e) => {
        const { normalize: n } = e;
        return n(["Crear una nueva cuenta"]);
      },
      "create-password": (e) => {
        const { normalize: n } = e;
        return n(["Crear contrase\xF1a"]);
      },
      "check-email": (e) => {
        const { normalize: n } = e;
        return n(["Revise su email ahora "]);
      },
      "common-error-message": (e) => {
        const { normalize: n } = e;
        return n(["Lo sentimos, se ha producido un error. Actualice su navegador o int\xE9ntelo m\xE1s tarde."]);
      },
      "invalid-password-message": (e) => {
        const { normalize: n } = e;
        return n(["Por favor, introduza una contrase\xF1a v\xE1lida."]);
      },
      "invalid-email-message": (e) => {
        const { normalize: n } = e;
        return n(["Por favor, introduza una direcci\xF3n de correo electr\xF3nico v\xE1lida."]);
      },
      "reset-password-success-first-message": (e) => {
        const { normalize: n, interpolate: r, named: o } = e;
        return n(["We have emailed ", r(o("email")), " instructions on how to create a new password."]);
      },
      "reset-password-success-second-message": (e) => {
        const { normalize: n } = e;
        return n(["Open the email and follow the instructions to continue."]);
      },
      "error-alert-title": (e) => {
        const { normalize: n } = e;
        return n(["Error"]);
      },
      "success-alert-title": (e) => {
        const { normalize: n } = e;
        return n(["\xC9xito!"]);
      },
      dialog: {
        "creating-account": (e) => {
          const { normalize: n } = e;
          return n(["Creando cuenta"]);
        },
        "signing-in": (e) => {
          const { normalize: n } = e;
          return n(["Iniciar sesi\xF3n"]);
        },
        "recovery-email": (e) => {
          const { normalize: n } = e;
          return n(["Enviando correo email de recuperaci\xF3n"]);
        },
        "answer-saved-header": (e) => {
          const { normalize: n, interpolate: r, named: o } = e;
          return n(["Your ", r(o("productName")), " is Saved"]);
        },
        "signed-in": {
          "answer-saved-message": (e) => {
            const { normalize: n, interpolate: r, named: o } = e;
            return n(["Your ", r(o("productName")), " has been saved to your ", r(o("siteBrand")), " account."]);
          }
        },
        "create-account": {
          "answer-saved-message": (e) => {
            const { normalize: n, interpolate: r, named: o } = e;
            return n(["You have created an account with ", r(o("siteBrand")), ". We will send you a confirmation email shortly."]);
          }
        },
        "answer-saved-message1": (e) => {
          const { normalize: n, interpolate: r, named: o } = e;
          return n(["You can return and finish your ", r(o("productName")), " whenever you like."]);
        }
      },
      email: (e) => {
        const { normalize: n } = e;
        return n(["Email"]);
      },
      "email-policy": (e) => {
        const { normalize: n } = e;
        return n(["Pol\xEDtica de comunicaciones comerciales electr\xF3nicas"]);
      },
      "forgot-password": (e) => {
        const { normalize: n } = e;
        return n(["No me acuerdo de mi contrase\xF1a"]);
      },
      "if-you-prefer": (e) => {
        const { normalize: n, interpolate: r, named: o } = e;
        return n(["Si prefiere, puede ", r(o("create")), " o ", r(o("return")), "."]);
      },
      "no-account-text": (e) => {
        const { normalize: n } = e;
        return n(["\xBFNo tiene cuenta?"]);
      },
      "no-thanks": (e) => {
        const { normalize: n } = e;
        return n(["No, gracias"]);
      },
      password: (e) => {
        const { normalize: n } = e;
        return n(["Contrase\xF1a"]);
      },
      "password-email-sent": (e) => {
        const { normalize: n } = e;
        return n(["Se ha enviado un email con la contrase\xF1a"]);
      },
      "password-reset": (e) => {
        const { normalize: n } = e;
        return n(["Cambio de contrase\xF1a"]);
      },
      "password-reset-instructions": (e) => {
        const { normalize: n } = e;
        return n(["Te enviaremos por email las instrucciones para restablecer su contrase\xF1a."]);
      },
      "return-sign-in": (e) => {
        const { normalize: n } = e;
        return n(["Volver a iniciar sesi\xF3n"]);
      },
      "sign-in": (e) => {
        const { normalize: n } = e;
        return n(["Iniciar sesi\xF3n"]);
      },
      "sign-in-text": (e) => {
        const { normalize: n, interpolate: r, named: o } = e;
        return n(["Inicie sesi\xF3n ", r(o("SiteBrand")), " en su cuenta"]);
      },
      "save-document": (e) => {
        const { normalize: n } = e;
        return n(["Guardar mi documento"]);
      },
      "save-product-create-text": (e) => {
        const { normalize: n, interpolate: r, named: o } = e;
        return n(["Guarde su ", r(o("productName")), " creando una cuenta gratuita"]);
      },
      "save-product-login-text": (e) => {
        const { normalize: n, interpolate: r, named: o } = e;
        return n(["Inicie sesi\xF3n para guardar su ", r(o("productName"))]);
      }
    },
    "redirect-prompt": {
      "your-country-is-set-to": (e) => {
        const { normalize: n, interpolate: r, named: o } = e;
        return n(["Su pa\xEDs est\xE1 configurado como ", r(o("countryName"))]);
      },
      "change-to": (e) => {
        const { normalize: n, interpolate: r, named: o } = e;
        return n(["Cambiar a ", r(o("countryName"))]);
      },
      "dont-change": (e) => {
        const { normalize: n } = e;
        return n(["No cambiar"]);
      }
    }
  }
};
export {
  a as default
};
//# sourceMappingURL=index.js.map
